import React from 'react';
import { Carousel } from 'react-bootstrap';
import slides from '../data/heroSlides';
import './HeroSlider.css';
import { useLocation } from 'react-router-dom';

function HeroSlider() {
  console.log(slides);
  const location = useLocation();
  
  if (location.pathname !== "/") {
    return null;
  }

  // 7th (index 6), 8th (index 7), 9th (index 8) remove — baaki sab show + 10th (index 9)
  const limitedSlides = slides.filter((_, i) => i < 6 || i === 9);

  return (
    <Carousel fade indicators={true} interval={3000} controls={false}>
      {limitedSlides.map((s, i) => (
        <Carousel.Item key={i}>
          <div className="slide-content">
            <img className="d-block w-100 slide-img" src={s.img} alt={s.title} />
            <div className="text-box">
              <h2>{s.title}</h2>
              <p>{s.description}</p>
            </div>
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default HeroSlider;